export default __webpack_public_path__ + "static/media/redux.0a4a6ca2.svg";